var ClientManage = function () { return import('~/pages/case-import/client-manage.vue'); };
// const AbnormalCase = () => import('~/pages/case-import/abnormal-case.vue')
var UndistributedCase = function () { return import('~/pages/case-import/undistributed-case.vue'); };
var AllocatedCase = function () { return import('~/pages/case-import/allocated-case.vue'); };
var IntroductionCase = function () { return import('~/pages/case-import/introduction-case.vue'); };
var RecoveredCase = function () { return import('~/pages/case-import/recovered-case.vue'); };
var RepaymentConfirmation = function () { return import('~/pages/case-import/repayment-confirmation.vue'); };
export default [
    {
        path: '/case-import/client-manage',
        name: 'client-manage',
        component: ClientManage
    },
    {
        path: '/case-import/repayment-confirmation',
        name: 'repayment-confirmation',
        title: '还款确认',
        component: RepaymentConfirmation
    },
    {
        path: '/case-import/undistributed-case',
        name: 'undistributed-case',
        component: UndistributedCase
    },
    {
        path: '/case-import/allocated-case',
        name: 'allocated-case',
        title: '已分配案件',
        component: AllocatedCase
    },
    {
        path: '/case-import/introduction-case',
        name: 'introduction-case',
        component: IntroductionCase
    },
    {
        path: '/case-import/recovered-case',
        name: 'recovered-case',
        component: RecoveredCase
    },
];
